import {getEnvironment} from "./environmantDetection";

class adobeDTM {
    init() {
        this.addOmnitureDTLScript();
    }

    addOmnitureDTLScript() {
        var src =
            "https://www." +
            getEnvironment("SCRIPT") +
            "shutterfly.com/rest/omnitureDTL/adobeDTM.siteCatalyst.DTL?esch=1";
        var script = document.createElement("script");
        script.setAttribute("src", src);
        script.async = false;
        document.getElementsByTagName("head")[0].appendChild(script);
    }

    fireAdditionalRule(dtlData, url) {
        var host = window.location.origin;
        //remove the event and page information because merged data stays in SFLY_DTL
        window.$omnitureDTL.removeOmnitureJSPData(host, "event");

        //wait till some JSP posts omniture data into the DTL buffer
        window.$omnitureDTL.processOmnitureJSPData(null);

        //wait until the DTL buffer is available, and then fill it with this new JSP data.
        window.$omnitureDTL.putOmnitureJSPData(host, dtlData);

        //setTimeout(function() {
        //  window.location.href = url;
        //}, 100);
    }

    clickDTMEvent(location, url, logAdditionalRules) {
        var dtlData = {
            event: {
                eventInfo: {eventName: "generic event"},
                eventDetails: {
                    eventLocation: "share-product:" + location
                }
            },
            delayedPageLoad: true
        };
        if (logAdditionalRules === "true")
            this.fireAdditionalRule(dtlData, url);
    }

    putOmnitureJSPData = (appServerURL, jspData) => {
        setTimeout(() => {
            this.fireAdditionalRule(jspData);
        }, 100);
    }
}

export default adobeDTM;
